import React from "react";
import { Chip } from "@mui/material";

// TEBA member status from the API (`status` on get_members / member_profile).
export const MEMBER_STATUS_META = {
  active: { label: "Active", color: "#2ecc71" },
  payment_pending: { label: "Payment Pending", color: "#f39c12" },
  inactive: { label: "Inactive", color: "#95a5a6" },
};

export const MEMBER_STATUS_OPTIONS = Object.entries(MEMBER_STATUS_META).map(([value, meta]) => ({
  value,
  label: meta.label,
}));

const MemberStatusChip = ({ status, size = "small", sx }) => {
  const meta = MEMBER_STATUS_META[status];
  if (!meta) return null;
  return (
    <Chip
      label={meta.label}
      size={size}
      sx={{
        backgroundColor: `${meta.color}33`,
        color: meta.color,
        border: `1px solid ${meta.color}`,
        fontWeight: 700,
        ...sx,
      }}
    />
  );
};

/** Staff-only marker for a member with a free card (never shown to members themselves). */
export const FreeCardChip = ({ size = "small", sx }) => (
  <Chip
    label="Free card"
    size={size}
    variant="outlined"
    sx={{ borderColor: "#3498db", color: "#3498db", fontWeight: 700, ...sx }}
  />
);

export default MemberStatusChip;
